<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Solicitação de Reembolso</div>
            </div>
            <hr style="margin-top: -4px" />
            
            <!-- ✅ SEÇÃO: Dados da Solicitação -->
            <div class="col-12 mt-4 mb-2">
              <div
                :class="[
                  'reimbursement-card',
                  $store.state.appConfig.layout.skin === 'dark'
                    ? 'reimbursement-card-dark'
                    : 'reimbursement-card-light',
                ]"
              >
                <div class="reimbursement-card-header">
                  <i
                    class="fas fa-user-circle text-primary"
                    style="font-size: 22px"
                  ></i>
                  <h3 class="mb-0 text-primary reimbursement-card-title">
                    Dados da Solicitação
                  </h3>
                  <div class="reimbursement-card-line reimbursement-card-line-primary"></div>
                </div>

                <div class="row">
                  <div class="col-md-5">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      <span class="required">*</span> Nome do Colaborador
                    </label>
                    <v-select 
                      v-model="reimbursement_solicitation.user_id" 
                      :options="users" 
                      :reduce="(user) => user.id"
                      :label="'name'"
                      :filter="customFilterUsers"
                      @input="fillUserData"
                    ></v-select>
                  </div>

                  <div class="col-md-5">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      <span class="required">*</span> Valor do adiantamento
                    </label>
                    <input 
                      v-model="advance_amount" 
                      type="text" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      v-money="moneyConfig" 
                      disabled 
                    />
                  </div>

                  <div class="col-md-2">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      Data
                    </label>
                    <input 
                      autocomplete="new-password" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      id="date" 
                      placeholder="" 
                      type="date"
                      v-model="reimbursement_solicitation.date" 
                      disabled 
                    />
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-4">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      <span class="required">*</span> Banco
                    </label>
                    <input 
                      v-model="reimbursement_solicitation.deposit_bank" 
                      type="text" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                    />
                  </div>

                  <div class="col-md-4">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      <span class="required">*</span> Agência
                    </label>
                    <input 
                      v-model="reimbursement_solicitation.branch" 
                      type="text" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      v-mask="'9999'" 
                    />
                  </div>

                  <div class="col-md-4">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      Conta Corrente
                    </label>
                    <input 
                      v-model="reimbursement_solicitation.checking_account" 
                      type="text" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                    />
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-6">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      Tipo de Chave Pix
                    </label>
                    <v-select 
                      v-model="reimbursement_solicitation.pix_key"
                      :options="reimbursement_solicitation.pixOptions" 
                      placeholder="Selecione a chave" 
                      id="pixKey"
                      class="custom-v-select"
                    ></v-select>
                  </div>

                  <div class="col-md-6" v-if="reimbursement_solicitation.pix_key">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      Valor da Chave Pix
                    </label>
                    <input 
                      v-model="reimbursement_solicitation.pix_value" 
                      :key="reimbursement_solicitation.pix_key" 
                      :type="reimbursement_solicitation.pix_key === 'E-Mail' ? 'email' : 'text'"
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      id="pixValue" 
                      placeholder="Digite sua chave pix" 
                      v-mask="pixMask" 
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- ✅ SEÇÃO: Despesas -->
            <div class="col-12 mt-4 mb-2">
              <div
                :class="[
                  'reimbursement-card',
                  $store.state.appConfig.layout.skin === 'dark'
                    ? 'reimbursement-card-dark'
                    : 'reimbursement-card-light',
                ]"
              >
                <div class="reimbursement-card-header">
                  <i
                    class="fas fa-receipt text-warning"
                    style="font-size: 22px"
                  ></i>
                  <h3 class="mb-0 text-warning reimbursement-card-title">
                    Adicionar Nova Despesa
                  </h3>
                  <div 
                    class="reimbursement-card-line"
                    style="border-color: #ffc107; margin-bottom: 2px"
                  ></div>
                </div>

                <div class="row">
                  <div class="col-md-2">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      <span class="required">*</span> Data da Despesa
                    </label>
                    <input 
                      v-model="date_reimbursement" 
                      type="date" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      max="9999-12-31" 
                    />
                  </div>

                  <div class="col-md-5">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      Tipo de Despesa
                    </label>
                    <v-select 
                      v-model="reimbursement_type_id" 
                      :options="reimbursement_types"
                      :reduce="(type) => type.id" 
                      :label="'name'"
                    ></v-select>
                  </div>

                  <div class="col-md-3" v-show="isRateio">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      Centro de Custo
                    </label>
                    <v-select 
                      v-model="bill_center_ids" 
                      :options="bill_centers"
                      :reduce="(bill_center) => bill_center.id" 
                      :label="'number_name'" 
                      multiple
                    ></v-select>
                  </div>

                  <div class="col-md-3" v-show="!isRateio">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      Centro de Custo
                    </label>
                    <v-select 
                      v-model="bill_center_id" 
                      :options="bill_centers"
                      :reduce="(bill_center) => bill_center.id" 
                      :label="'number_name'"
                    ></v-select>
                  </div>

                  <div class="col-md-2 mt-2">
                    <div class="custom-control custom-switch">
                      <input 
                        autocomplete="new-password" 
                        placeholder="" 
                        type="checkbox" 
                        class="custom-control-input"
                        id="customSwitch1" 
                        v-model="isRateio" 
                      />
                      <label class="custom-control-label" for="customSwitch1">
                        É rateio?
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-12">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      <span class="required">*</span> Descrição da Despesa
                    </label>
                    <textarea 
                      v-model="expense_description" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      id="expense_description" 
                      cols="20"
                      rows="3"
                    ></textarea>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-6">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      <span class="required">*</span> Valor
                    </label>
                    <input 
                      v-model="amount" 
                      type="text" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      v-money="moneyConfig" 
                    />
                  </div>

                  <div class="col-md-6">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      Arquivo
                    </label>
                    <input 
                      type="file" 
                      id="images" 
                      ref="file" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                    />
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-12 text-right">
                    <button class="btn btn-primary" @click="incluirReembolso">
                      <i class="fas fa-plus"></i> Incluir Despesa
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- ✅ SEÇÃO: Itens de Reembolso -->
            <div class="col-12 mt-4 mb-2" v-if="reimbursements.length > 0">
              <div
                :class="[
                  'reimbursement-card',
                  $store.state.appConfig.layout.skin === 'dark'
                    ? 'reimbursement-card-dark'
                    : 'reimbursement-card-light',
                ]"
              >
                <div class="reimbursement-card-header">
                  <i
                    class="fas fa-list text-success"
                    style="font-size: 22px"
                  ></i>
                  <h3 class="mb-0 text-success reimbursement-card-title">
                    Itens de Reembolso
                  </h3>
                  <div
                    class="reimbursement-card-line"
                    style="border-color: #28a745; margin-bottom: 2px"
                  ></div>
                </div>

                <div class="col-md-12">
                  <table class="table table-bordered" style="width: 100%">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 20%">Data da Despesa</th>
                        <th scope="col" style="width: 20%">Tipo da Despesa</th>
                        <th scope="col" style="width: 20%">
                          Descrição da Despesa
                        </th>
                        <th scope="col" style="width: 20%">Centro de Custo</th>
                        <th scope="col" style="width: 20%">Valor</th>
                        <th scope="col" style="width: 20%">Arquivos</th>
                        <th scope="col" style="width: 20%">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(reimbursement, index) in reimbursements" :key="index">
                        <td>{{ reimbursement.date_reimbursement }}</td>
                        <td>
                          {{
                            getReimbursementTypeName(
                              reimbursement.reimbursement_type_id
                            )
                          }}
                        </td>
                        <td>{{ reimbursement.expense_description }}</td>
                        <td v-if="
                          Array.isArray(reimbursement.bill_center_ids) &&
                          reimbursement.bill_center_ids.length > 0
                        ">
                          {{
                            getBillCenterNames(reimbursement.bill_center_ids)
                          }}
                        </td>
                        <td v-else-if="
                          reimbursement.bill_center_id !== null &&
                          reimbursement.bill_center_id !== undefined
                        ">
                          {{ getBillCenterName(reimbursement.bill_center_id) }}
                        </td>
                        <td v-if="
                          reimbursement.bill_center_ids.length === 0 &&
                          !reimbursement.bill_center_id
                        ">
                          Centro de custo não disponível
                        </td>
                        <td>{{ formatCurrency(reimbursement.amount) }}</td>
                        <td>
                          {{
                            reimbursement && reimbursement.files
                              ? reimbursement.files.name
                              : "Nenhum Arquivo"
                          }}
                        </td>
                        <td>
                          <button class="btn btn-crud delete" @click="remove(index)">
                            <i class="far fa-trash-alt" data-toggle="tooltip" title="Excluir"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- ✅ SEÇÃO: Resumo Financeiro -->
            <div class="col-12 mt-4 mb-2">
              <div
                :class="[
                  'reimbursement-card',
                  $store.state.appConfig.layout.skin === 'dark'
                    ? 'reimbursement-card-dark'
                    : 'reimbursement-card-light',
                ]"
              >
                <div class="reimbursement-card-header">
                  <i
                    class="fas fa-calculator text-info"
                    style="font-size: 22px"
                  ></i>
                  <h3 class="mb-0 text-info reimbursement-card-title">
                    Resumo Financeiro
                  </h3>
                  <div
                    class="reimbursement-card-line"
                    style="border-color: #17a2b8; margin-bottom: 2px"
                  ></div>
                </div>

                <div class="row">
                  <div class="col-md-6" v-if="!reimbursement_solicitation.is_dinner_advance">
                    <label
                      :class="[
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light',
                      ]"
                    >
                      <span class="required">*</span> Saldo a receber (devolver)
                    </label>
                    <input 
                      :value="formatCurrency(reimbursement_solicitation.balance_to_receive)"
                      type="text" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      v-money="moneyConfig" 
                      disabled 
                    />
                    <span v-if="reimbursement_solicitation.balance_to_receive > 0" class="text-danger">
                      (Devolver a IT4D)
                    </span>
                    <span v-else-if="reimbursement_solicitation.balance_to_receive < 0" class="text-success">
                      (Devolver ao Colaborador)
                    </span>
                  </div>

                  <div :class="reimbursement_solicitation.is_dinner_advance ? 'col-md-12' : 'col-md-6'">
                    <label
                      :class="[
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light',
                      ]"
                    >
                      <span class="required">*</span> Total dos gastos
                    </label>
                    <input 
                      :value="formatCurrency(reimbursement_solicitation.total_expenses)"
                      type="text" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      v-money="moneyConfig" 
                      disabled 
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <span class="required_fields">
                <span class="required">*</span>
                <strong>Campos obrigatórios</strong>
              </span>
              <div class="block text-right mb-1">
                <router-link :to="backRoute" class="btn btn-back">
                  <i class="fa fa-arrow-left"></i> Voltar
                </router-link>
                <a class="btn btn-secondary ml-1" @click="partialSave">
                  Salvar parcial <i class="fa fa-save"></i>
                </a>

                <a class="btn btn-add ml-1" @click="save">
                  Salvar
                  <i class="fa fa-save"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Money from "v-money";

export default {
  name: "imageUpload",
  data() {
    return {
      isRateio: false,
      bill_center_ids: [],
      moneyConfig: {
        prefix: "R$ ",
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false,
      },
      reimbursement_solicitation: {
        user_id: "",
        date: "",
        checking_account: "",
        balance_to_receive: 0,
        branch: "",
        deposit_bank: "",
        bill_center_id: "",
        total_expenses: 0,
        approve: 0,
        pix_key: "", // Tipo da chave Pix (CPF, CNPJ, Telefone, E-Mail)
        pix_value: "", // Valor da chave Pix
        pixOptions: ["CPF", "CNPJ", "Telefone", "E-Mail"],
      },
      reimbursements: [],
      reimbursement_types: [],
      expense_description: "",
      reimbursement_solicitation_id: "",
      reimbursement_type_id: "",
      bill_center_id: "",
      amount: "",
      advance_amount: "",
      date_reimbursement: "",
      file: "",
      bill_centers: [],
      users: [],
      base64: "",
      // Campos para a Chave Pix
    };
  },
  computed: {
    backRoute() {
      // Detecta se é adiantamento para voltar para a tela correta
      const advanceValue = this.convertCurrencyToNumber(this.advance_amount);
      const isAdvance = advanceValue > 0;
      return isAdvance ? '/advances' : '/reimbursement_solicitations';
    },

    pixMask() {
      switch (this.reimbursement_solicitation.pix_key) {
        case "CPF":
          return "999.999.999-99";
        case "CNPJ":
          return "99.999.999/9999-99";
        case "Telefone":
          return "(99) 99999-9999";
        default:
          return ""; // Para E-Mail ou sem seleção, nenhuma máscara
      }
    },

    isAccessNivel() {
      return this.$store.state.user.perfil_id === 8 || this.$store.state.user.perfil_id === 7;
    },

    canSaveAdvance() {
      return (
        this.reimbursement_solicitation.user_id &&
        this.advance_amount &&
        this.convertCurrencyToNumber(this.advance_amount) > 0
      );
    },

  },
  watch: {
    isRateio(newVal, oldVal) {
      if (newVal) {
        this.bill_center_id = null;
      } else {
        this.bill_center_ids = [];
      }
    },
  },
  methods: {

    // Função para normalizar strings removendo acentos
    normalizeString(str) {
      if (!str) return '';
      return str
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    },

    // Filtro customizado para busca de usuários ignorando acentos
    customFilterUsers(options, search) {
      const normalizedSearch = this.normalizeString(search);
      return options.filter(option => {
        const normalizedName = this.normalizeString(option.name);
        return normalizedName.includes(normalizedSearch);
      });
    },

    async partialSave() {
      const self = this;

      // Validação mínima
      if (!self.reimbursement_solicitation.user_id) {
        self.$message(null, "Selecione o colaborador antes de salvar.", "error");
        return;
      }

      if (!self.advance_amount) {
        self.$message(null, "O Valor do adiantamento é obrigatório.", "error");
        return;
      }

      // Monta a requisição
      let api = self.$store.state.api + "reimbursement_solicitations";
      const fd = new FormData();

      // Se já existir, usa PUT via _method
      if (self.reimbursement_solicitation.id) {
        api += "/" + self.reimbursement_solicitation.id;
        fd.append("_method", "PUT");
      }

      // Dados principais
      fd.append("reimbursement_solicitation[user_id]", self.reimbursement_solicitation.user_id);
      fd.append("reimbursement_solicitation[date]", self.reimbursement_solicitation.date || moment().format("YYYY-MM-DD"));
      
      // ✅ Determina se é adiantamento ou solicitação comum baseado no valor
      const advanceValue = self.convertCurrencyToNumber(self.advance_amount);
      const isAdvance = advanceValue > 0 ? 1 : 0;
      
      fd.append("reimbursement_solicitation[advance_amount]", advanceValue);
      fd.append("reimbursement_solicitation[is_advance]", isAdvance);

      // 💡 Aqui forçamos o status como "Aguardando Prestação de Contas"
      fd.append("reimbursement_solicitation[approve]", 4);

      // Dados bancários e Pix
      fd.append("reimbursement_solicitation[deposit_bank]", self.reimbursement_solicitation.deposit_bank || "");
      fd.append("reimbursement_solicitation[branch]", self.reimbursement_solicitation.branch || "");
      fd.append("reimbursement_solicitation[checking_account]", self.reimbursement_solicitation.checking_account || "");
      fd.append("reimbursement_solicitation[pix_key]", self.reimbursement_solicitation.pix_key || "");
      fd.append("reimbursement_solicitation[pix_value]", self.reimbursement_solicitation.pix_value || "");

      // Reembolsos (despesas)
      (self.reimbursements || []).forEach((element, index) => {
        fd.append(`reimbursements[${index}][reimbursement_type_id]`, element.reimbursement_type_id);
        fd.append(`reimbursements[${index}][expense_description]`, element.expense_description || "");
        fd.append(`reimbursements[${index}][amount]`, element.amount || 0);
        fd.append(`reimbursements[${index}][date_reimbursement]`, element.date_reimbursement || "");

        if (element.bill_center_id) {
          fd.append(`reimbursements[${index}][bill_center_id]`, element.bill_center_id);
        }
        if (element.bill_center_ids && Array.isArray(element.bill_center_ids)) {
          element.bill_center_ids.forEach((id) => {
            fd.append(`reimbursements[${index}][bill_center_ids][]`, id);
          });
        }

        if (element.files) fd.append(`reimbursements[${index}][files]`, element.files);
      });

      try {
        self.$loading(true);
        const response = await axios.post(api, fd);
        self.$message("Sucesso", "Solicitação salva parcialmente como Aguardando Prestação de Contas.", "success");

        // Se é uma nova solicitação (não tem ID), redireciona para edição
        if (!self.reimbursement_solicitation.id) {
          // Função para buscar ID em diferentes estruturas
          const findId = (data) => {
            return data?.id ||
              data?.data?.id ||
              data?.reimbursement_solicitation?.id ||
              (Array.isArray(data?.data) ? data?.data[0]?.id : null) ||
              (Array.isArray(data) ? data[0]?.id : null);
          };

          let createdId = findId(response.data);

          if (createdId) {
            self.$router.push(`/reimbursement_solicitations/edit/${createdId}`);
          } else {
            // Fallback: busca a última solicitação do usuário
            try {
              const lastResponse = await axios.get(self.$store.state.api + `reimbursement_solicitations?user_id=${self.reimbursement_solicitation.user_id}&limit=1&orderBy=created_at&orderDirection=desc`);
              const lastId = findId(lastResponse.data);

              if (lastId) {
                self.$router.push(`/reimbursement_solicitations/edit/${lastId}`);
              } else {
                self.$router.push(this.backRoute);
              }
            } catch (fallbackError) {
              self.$router.push(this.backRoute);
            }
          }
        }
      } catch (err) {
        self.$message(null, err?.response?.data || "Falha ao salvar parcialmente.", "error");
      } finally {
        self.$loading(false);
      }
    },

    async saveAdvance() {
      const self = this;

      if (!self.reimbursement_solicitation.user_id) {
        this.$message(null, "O Nome do Colaborador é obrigatório", "error");
        return;
      }

      if (!self.advance_amount) {
        this.$message(null, "O Valor do adiantamento é obrigatório", "error");
        return;
      }

      const api = self.$store.state.api + "reimbursement_solicitations";
      const fd = new FormData();

      const currentDate = new Date().toISOString().split("T")[0];

      fd.append("reimbursement_solicitation[user_id]", self.reimbursement_solicitation.user_id);
      fd.append("reimbursement_solicitation[date]", currentDate);

      // valor do adiantamento (numérico)
      fd.append(
        "reimbursement_solicitation[advance_amount]",
        self.convertCurrencyToNumber(self.advance_amount)
      );

      // ✅ status 4: Aguardando Prestação de Contas
      fd.append("reimbursement_solicitation[approve]", 4);

      // flag para diferenciar que é um lançamento de adiantamento
      fd.append("reimbursement_solicitation[is_advance]", 1);

      // opcional: dados bancários do usuário, se já vierem preenchidos
      if (self.reimbursement_solicitation.deposit_bank) {
        fd.append("reimbursement_solicitation[deposit_bank]", self.reimbursement_solicitation.deposit_bank);
      }
      if (self.reimbursement_solicitation.branch) {
        fd.append("reimbursement_solicitation[branch]", self.reimbursement_solicitation.branch);
      }
      if (self.reimbursement_solicitation.checking_account) {
        fd.append("reimbursement_solicitation[checking_account]", self.reimbursement_solicitation.checking_account);
      }

      // sem despesas no momento do adiantamento
      fd.append("reimbursements", JSON.stringify([]));

      try {
        self.$loading(true);
        const { data } = await axios.post(api, fd);
        this.$message("Sucesso", "Adiantamento salvo com sucesso", "success");

        // redireciona para edição da ocorrência (já no status 4) ou para a lista
        if (data && data.id) {
          this.$router.push(`/reimbursement_solicitations/edit/${data.id}`);
        } else {
          this.$router.push("/advances");
        }
      } catch (error) {
        this.$message(null, error?.response?.data || "Erro ao salvar adiantamento", "error");
      } finally {
        self.$loading(false);
      }
    },

    getReimbursementTypeName(reimbursementTypeId) {
      const reimbursementType = this.reimbursement_types.find(
        (type) => type.id === reimbursementTypeId
      );
      return reimbursementType ? reimbursementType.name : "Tipo não encontrado";
    },
    getBillCenterNames(billCenterIds) {
      const ids = Array.isArray(billCenterIds)
        ? billCenterIds
        : billCenterIds.split(",").map((id) => parseInt(id, 10));
      const names = ids.map((id) => {
        const billCenter = this.bill_centers.find(
          (bill_center) => bill_center.id === id
        );
        return billCenter
          ? billCenter.number_name
          : "Centro de custo não encontrado";
      });
      return names.join(", ");
    },
    getBillCenterName(billCenterId) {
      const billCenter = this.bill_centers.find(
        (bill_center) => bill_center.id === billCenterId
      );
      return billCenter
        ? billCenter.number_name
        : "Centro de custo não encontrado";
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    convertCurrencyToNumber(currencyString) {
      const cleanedString = currencyString
        .replace(/\s|R\$/g, "")
        .replace(".", "");
      const dotFormattedString = cleanedString.replace(",", ".");
      const numberValue = parseFloat(dotFormattedString);
      return isNaN(numberValue) ? 0 : numberValue;
    },
    remove(index) {
      this.reimbursements.splice(index, 1);
      this.calculateTotalExpenses();
      this.calculateBalanceToReceive();
    },
    incluirReembolso() {
      const self = this;
      let fileInput = document.getElementById("images");
      const file = fileInput.files[0];

      if (this.reimbursement_type_id === "") {
        this.$message(null, "O tipo da despesa é obrigatório", "error");
        return;
      }
      if (this.date_reimbursement === "") {
        this.$message(null, "A data da despesa é obrigatória", "error");
        return;
      }
      if (!file) {
        this.$message(null, "O arquivo é obrigatório", "error");
        return;
      }
      const today = new Date();
      const reimbursementDate = new Date(this.date_reimbursement);
      if (reimbursementDate > today) {
        this.$message(
          null,
          "A data da despesa não pode ser maior que hoje",
          "error"
        );
        return;
      }
      if (this.expense_description === "") {
        this.$message(null, "A descrição da despesa é obrigatória", "error");
        return;
      }
      if (this.isRateio) {
        if (
          !Array.isArray(this.bill_center_ids) ||
          this.bill_center_ids.length === 0
        ) {
          this.$message(null, "Selecione ao menos um centro de custo", "error");
          return;
        }
      } else {
        if (!this.bill_center_id) {
          this.$message(null, "O centro de custo é obrigatório", "error");
          return;
        }
      }
      const amountNumber = this.convertCurrencyToNumber(this.amount);
      const advanceAmountNumber = this.convertCurrencyToNumber(
        this.advance_amount
      );
      const newReimbursement = {
        reimbursement_type_id: self.reimbursement_type_id,
        expense_description: self.expense_description,
        amount: amountNumber,
        advance_amount: advanceAmountNumber,
        date_reimbursement: self.date_reimbursement,
        files: file,
        bill_center_id: self.bill_center_id,
        bill_center_ids: self.bill_center_ids,
      };
      self.reimbursements.push(newReimbursement);
      self.expense_description = "";
      self.reimbursement_type_id = "";
      self.amount = "";
      self.$refs.file.value = "";
      self.date_reimbursement = "";
      self.bill_center_id = "";
      self.bill_center_ids = [];
      self.isRateio = false;
      self.calculateTotalExpenses();
      self.calculateBalanceToReceive();
    },
    makeFormData() {
      const fd = new FormData();
      fd.append("_method", "POST");
      return fd;
    },
    save() {
      const self = this;
      if (
        this.reimbursement_solicitation.user_id === "" ||
        this.reimbursement_solicitation.user_id === null
      ) {
        this.$message(null, "O Nome é obrigatório", "error");
        return false;
      }
      if (
        this.reimbursement_solicitation.date === "" ||
        this.reimbursement_solicitation.date === null
      ) {
        this.$message(null, "A Data é obrigatória", "error");
        return false;
      }
      if (
        this.reimbursement_solicitation.deposit_bank === "" ||
        this.reimbursement_solicitation.deposit_bank === null
      ) {
        this.$message(null, "O Banco é obrigatório", "error");
        return false;
      }
      if (
        this.reimbursement_solicitation.branch === "" ||
        this.reimbursement_solicitation.branch === null
      ) {
        this.$message(null, "A Agência é obrigatória", "error");
        return false;
      }
      if (
        this.reimbursement_solicitation.checking_account === "" ||
        this.reimbursement_solicitation.checking_account === null
      ) {
        this.$message(null, "A Conta Corrente é obrigatória", "error");
        return false;
      }
      if (this.reimbursement_solicitation.total_expenses === 0) {
        this.$message(
          null,
          "O Total não pode ser 0, favor informar um Valor.",
          "error"
        );
        return false;
      }
      let api = self.$store.state.api + "reimbursement_solicitations";
      let fd = self.makeFormData();
      if (self.reimbursement_solicitation.id) {
        api += "/" + self.reimbursement_solicitation.id;
        self.reimbursement_solicitation._method = "PUT";
      }
      fd.append(
        "reimbursement_solicitation[user_id]",
        self.reimbursement_solicitation.user_id
      );
      fd.append(
        "reimbursement_solicitation[date]",
        self.reimbursement_solicitation.date
      );
      fd.append(
        "reimbursement_solicitation[checking_account]",
        self.reimbursement_solicitation.checking_account
      );
      fd.append(
        "reimbursement_solicitation[balance_to_receive]",
        self.reimbursement_solicitation.balance_to_receive
      );
      fd.append(
        "reimbursement_solicitation[pix_value]",
        self.reimbursement_solicitation.pix_value
      );
      fd.append(
        "reimbursement_solicitation[pix_key]",
        self.reimbursement_solicitation.pix_key
      );
      fd.append(
        "reimbursement_solicitation[branch]",
        self.reimbursement_solicitation.branch
      );
      fd.append(
        "reimbursement_solicitation[deposit_bank]",
        self.reimbursement_solicitation.deposit_bank
      );
      fd.append(
        "reimbursement_solicitation[total_expenses]",
        self.reimbursement_solicitation.total_expenses
      );
      fd.append(
        "reimbursement_solicitation[approve]",
        self.reimbursement_solicitation.approve
      );
      self.reimbursements.forEach((element, index) => {
        fd.append(
          "reimbursements[" + index + "][reimbursement_type_id]",
          element.reimbursement_type_id
        );
        fd.append(
          "reimbursements[" + index + "][expense_description]",
          element.expense_description
        );
        fd.append("reimbursements[" + index + "][amount]", element.amount);
        fd.append(
          "reimbursements[" + index + "][advance_amount]",
          element.advance_amount
        );
        fd.append(
          "reimbursements[" + index + "][date_reimbursement]",
          element.date_reimbursement
        );
        if (element.bill_center_id) {
          fd.append(
            "reimbursements[" + index + "][bill_center_id]",
            element.bill_center_id
          );
        }
        element.bill_center_ids.forEach((id) => {
          fd.append("reimbursements[" + index + "][bill_center_ids][]", id);
        });
        fd.append("reimbursements[" + index + "][files]", element.files);
      });
      self.$loading(true);
      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            "Informações guardadas com sucesso",
            "success"
          );
          this.$router.push(this.backRoute);
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    calculateTotalExpenses() {
      let totalExpenses = this.reimbursements.reduce((total, reimbursement) => {
        const amount = parseFloat(reimbursement.amount);
        return isNaN(amount) ? total : total + amount;
      }, 0);
      this.reimbursement_solicitation.total_expenses = totalExpenses;
    },
    calculateBalanceToReceive() {
      this.calculateTotalExpenses();
      
      // Se for adiantamento de jantar, o saldo a receber sempre é 0
      const isDinnerAdvance = Boolean(Number(this.reimbursement_solicitation.is_dinner_advance));
      if (isDinnerAdvance) {
        this.reimbursement_solicitation.balance_to_receive = 0;
      } else {
        this.reimbursement_solicitation.balance_to_receive =
          this.convertCurrencyToNumber(this.advance_amount) -
          this.reimbursement_solicitation.total_expenses;
      }
    },
    getReimbursementSolicitations(id) {
      const self = this;
      const api =
        self.$store.state.api +
        "reimbursement_solicitations/" +
        id +
        "?with[]=attachments&with[]=reimbursements";
      axios
        .get(api)
        .then((response) => {
          self.reimbursement_solicitation = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getReimbursementTypes() {
      const self = this;
      const api = self.$store.state.api + "reimbursement_types/";
      axios
        .get(api)
        .then((response) => {
          self.reimbursement_types = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getReimbursements(solicitation_id) {
      const self = this;
      let api =
        self.$store.state.api +
        `reimbursement_solicitations/${solicitation_id}/reimbursements`;
      axios
        .get(api)
        .then((response) => {
          self.reimbursements = response.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getBillCenters() {
      const self = this;
      const api = self.$store.state.api + "bill_centers?paginated=false";
      axios
        .get(api)
        .then((response) => {
          self.bill_centers = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsers() {
      const self = this;
      const api = self.$store.state.api + "users_solicitation?paginated=false";
      axios
        .get(api)
        .then((response) => {
          self.users = response.data.users;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    fillUserData(selectedUserId) {
      const selectedUser = this.users.find(
        (user) => user.id === selectedUserId
      );
      if (selectedUser) {
        this.reimbursement_solicitation.deposit_bank =
          selectedUser.deposit_bank || "";
        this.reimbursement_solicitation.branch = selectedUser.branch || "";
        this.reimbursement_solicitation.checking_account =
          selectedUser.checking_account || "";
        this.reimbursement_solicitation.pix_key = selectedUser.pix_key || "";
        this.reimbursement_solicitation.pix_value =
          selectedUser.pix_value || "";
      }
    },
  },
  mounted() {
    const self = this;
    let id = self.$route.params.id;
    self.getReimbursementTypes();
    self.getBillCenters();
    self.getUsers();
    if (id) {
      self.getReimbursementSolicitations(id);
      self.getReimbursements(id);
    } else {
      self.reimbursement_solicitation.date = moment().format("YYYY-MM-DD");
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Money,
  },
};
</script>

<style scoped>
.profile_user {
  text-align: center;
}

.attachment_url {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.attachment_url-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}

/* ===== ESTILIZAÇÃO MODERNA - IGUAL DASP/VIEW/EDIT ===== */

/* Cards - Classes separadas para dark e light */
.reimbursement-card {
  border-radius: 12px;
  padding: 24px 18px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.reimbursement-card-dark {
  background: #191e2e;
  border: 1px solid #4a5568;
}

.reimbursement-card-light {
  background: #f8f8fa;
  border: 1px solid #e2e6ea;
}

.reimbursement-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}

.reimbursement-card-title {
  font-weight: 700;
}

.reimbursement-card-line {
  flex: 1;
  border-bottom: 4px solid;
  margin-left: 16px;
  opacity: 0.6;
}

.reimbursement-card-line-primary {
  border-color: #007bff;
}

/* Labels */
.reimbursement-label-dark {
  color: #e2e8f0;
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}

.reimbursement-label-light {
  color: #2d3748;
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}

/* Inputs */
.reimbursement-input-dark {
  background: #2d3748;
  border: 1px solid #4a5568;
  color: #e2e8f0;
}

.reimbursement-input-light {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #2d3748;
}

/* Cards internos */
.reimbursement-inner-card-dark {
  background: #232b3e;
  border: 1px solid #4a5568;
  border-radius: 12px;
}

.reimbursement-inner-card-light {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 12px;
}

/* ===== RESPONSIVIDADE MOBILE ===== */
@media (max-width: 768px) {
  .reimbursement-card {
    padding: 1rem 0.75rem !important;
    margin-bottom: 1rem;
  }

  .reimbursement-card-header {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }

  .reimbursement-card-header i {
    font-size: 18px !important;
  }

  .reimbursement-card-title {
    font-size: 1.1rem !important;
    margin: 0 !important;
  }

  .reimbursement-card-line {
    width: 100%;
    margin-left: 0 !important;
    margin-top: 0.5rem;
  }

  .reimbursement-label-dark,
  .reimbursement-label-light {
    font-size: 0.9rem;
    margin-bottom: 0.25rem;
  }
}

/* ===== RESPONSIVIDADE TABLET ===== */
@media (min-width: 769px) and (max-width: 1024px) {
  .reimbursement-card {
    padding: 1.25rem;
  }
}
</style>
